import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * 수업 예약 회원의 체중(kg). 칼로리 계산용.
 * Api.ts 를 다시 생성하기 전이라 user.weight 는 타입에 없어 직접 꺼낸다.
 * memberCount 가 바뀌면(늦은 출석 등) 다시 읽는다.
 */
function useMemberWeights(
  classId: number | undefined,
  enabled: boolean,
  memberCount: number,
) {
  const [weights, setWeights] = useState<Record<number, number | null>>({});

  useEffect(() => {
    if (!enabled || classId === undefined) return;
    api.fits
      .reservationsDetail(classId)
      .then((res) => {
        const next: Record<number, number | null> = {};
        for (const reservation of res.data) {
          const user = reservation.user as
            | { id: number; weight?: number | null }
            | null;
          if (user) next[user.id] = user.weight ?? null;
        }
        setWeights(next);
      })
      .catch((e) => console.log(e));
  }, [classId, enabled, memberCount]);

  return weights;
}

export default useMemberWeights;
